import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';

import { CustomerRightsService, DiseaseModule } from '../services/customer-rights.service';
import { CropYearService } from '../services/crop-year.service';

/**
 * Allows navigation only when the given disease-monitoring module is activated
 * for the current customer. Non-activated customers and any failure of the
 * activation lookup are redirected to the application root.
 */
export const moduleActivationGuard =
  (module: DiseaseModule): CanActivateFn =>
    (_: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
      const router = inject(Router);
      const customerRightsService = inject(CustomerRightsService);
      const cropYearService = inject(CropYearService);

      return cropYearService.cropYear$.pipe(
        take(1),
        switchMap((cropYear) => customerRightsService.getModuleActivation(module, cropYear)),
        map((isActivated) => (isActivated ? true : router.createUrlTree(['/']))),
        catchError(() => of(router.createUrlTree(['/']))),
      );
    };
